import { render, staticRenderFns } from "./LayoutFullFirst.vue?vue&type=template&id=5a5a4bfc&"
import script from "./LayoutFullFirst.vue?vue&type=script&lang=js&"
export * from "./LayoutFullFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports